import i18n from '@yandex-int/i18n';

import { en } from './en';
import { ru } from './ru';

export const i18nHeader = i18n({ ru, en });
